import { Component } from '@angular/core';

// extends
import { LostPasswordPage } from "../../../lost-password/lost-password.page";

@Component({
    selector: 'app-lost-password',
    templateUrl: './lost-password.page.html',
    styleUrls: ['./lost-password.page.scss'],
})
export class CustomLostPasswordPage extends LostPasswordPage {
    /**
     * if we should show sidebar
     *
     * @type {boolean}
     */
    public hideSidebar: boolean = true;
}
